import { render, staticRenderFns } from "./page-bind.vue?vue&type=template&id=0e116322&scoped=true&"
import script from "./page-bind.vue?vue&type=script&lang=js&"
export * from "./page-bind.vue?vue&type=script&lang=js&"
import style0 from "./page-bind.vue?vue&type=style&index=0&id=0e116322&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e116322",
  null
  
)

export default component.exports